import { __assign } from "tslib";
import { EventsProvider } from '@magalu/ravejs-event-layer';
import React, { useEffect } from 'react';
import { useDataStore } from '../../wrappers/providers';
import { useRouter } from '../router';
var withEventsLayer = function (WrappedComponent, _a) {
    var events = _a.events, _b = _a.eventsCustomConfig, eventsCustomConfig = _b === void 0 ? {} : _b, routeInfo = _a.routeInfo, dataStoreSetupKey = _a.dataStoreSetupKey, _c = _a.clientProps, clientProps = _c === void 0 ? {} : _c;
    return function (pageProps) {
        var WithEventsLayerComp = function () {
            var _a = useRouter(), getCookies = _a.getCookies, query = _a.query, asPath = _a.asPath;
            var cookies = getCookies(); // use directly from router to inherit parser from page config
            var setInitData = useDataStore(function (state) { return state.setInitData; });
            var globalData = __assign(__assign(__assign(__assign({}, pageProps), clientProps), { cookies: cookies, route: __assign(__assign({}, routeInfo), { asPath: asPath, query: query }) }), eventsCustomConfig);
            var _b = pageProps.data, data = _b === void 0 ? {} : _b;
            // enable data-store by dataStoreSetupKey
            var dataStore = dataStoreSetupKey
                ? data[dataStoreSetupKey] || {}
                : {};
            useEffect(function () {
                if (dataStore && Object.keys(dataStore).length) {
                    setInitData(data);
                }
            }, [JSON.stringify(dataStore)]);
            return (React.createElement(EventsProvider, { events: events, globalData: globalData },
                React.createElement(WrappedComponent, __assign({}, pageProps))));
        };
        WithEventsLayerComp.displayName = "WithEventsLayer".concat(WrappedComponent.displayName || WrappedComponent.name);
        return WithEventsLayerComp();
    };
};
export default withEventsLayer;
//# sourceMappingURL=withEventsLayer.js.map